import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

export const Container = styled.div`
  background: #1a1a1a;
  width: 90%;
  max-width: 1100px;
  max-height: 90vh;
  border-radius: 12px;
  border: 1px solid #e6aa3a;
  padding: 30px;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  &:hover {
    color: #e6aa3a;
  }
`;

export const Title = styled.h2`
  color: #e6aa3a;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;

  div p {
    margin: 5px 0;
    color: #ccc;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  strong {
    color: #fff;
    display: block;
    font-size: 14px;
    margin-top: 2px;
  }
  .highlight {
    color: #e6aa3a;
    font-weight: 800;
  }
`;

export const TableSection = styled.div`
  margin-top: 20px;
  h3 {
    color: #fff;
    margin-bottom: 15px;
    font-size: 18px;
    border-left: 4px solid #e6aa3a;
    padding-left: 10px;
  }
`;

export const TableHeaderActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 15px;

  h3 {
    margin-bottom: 0 !important;
  }
`;

export const Controls = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;

  select {
    background: #2c2c2c;
    color: #fff;
    border: 1px solid #e6aa3a;
    padding: 6px 10px;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    font-size: 12px;
  }
`;

export const SortGroup = styled.div`
  display: flex;
  gap: 8px;

  button {
    background: #2c2c2c;
    color: #ccc;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.2s;

    &:hover {
      border-color: #e6aa3a;
      color: #fff;
    }

    &.active {
      background: rgba(230, 170, 58, 0.2);
      border-color: #e6aa3a;
      color: #e6aa3a;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 13px;
  }
  thead tr {
    background: rgba(230, 170, 58, 0.1);
  }
  th {
    color: #e6aa3a;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
  }
  .amount {
    font-weight: bold;
    color: #27ae60;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  color: #fff;
  font-size: 12px;

  button {
    background: transparent;
    color: #e6aa3a;
    border: 1px solid #e6aa3a;
    padding: 5px 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
    font-size: 12px;

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: #e6aa3a;
      color: #000;
    }
  }
`;
